import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  CircularProgress,
  Divider,
  Grid,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
} from "@material-ui/core";
import {
  AddRefrenceDataList,
  getRefrenceDataList,
  PutRefrenceDataList,
  deleteItem,
  getRefrenceDataListForOneRecord ,
} from "../adminaction";
import CustomSnackbar from "../../../../CustomSnackbar";
import { makeStyles } from "@material-ui/styles";
import { Backdrop } from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import { dashboardStyle } from "../../Components/InvoiceDetails/style";
import { ArrowBack, Delete, Error } from "@mui/icons-material";


const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const useStyles = makeStyles(dashboardStyle);

export default function SG_PM_TT_PTModel({
    refKey,
    getdata, 
  setOpenModel,
  updateId,
  setUpdateId,
  togglebutton,
  settogglebutton,
  deleteId,
  setDeleteID,
  setSuccessMessage,
  setErrorMessage,
  getdataFromID,
  setGetDataFromID,
  setGetData,
  
}) {
  const [open, setOpen] = useState(false);
  // const [locationOption, setLocationOption] = React.useState([]);
  const [checked, setChecked] = useState(false);
 const [loader, setLoader] = useState(false);
  const [formState, setFormState] = useState({
  referenceId: 0,
  referenceKey: refKey,
  referenceCode: "",
  referenceText: "",
  referenceProp1: "",
  referenceProp2: "",
  referenceProp3: "",
  referenceProp4: "",
  isActive: true,
});

  
  const classes = useStyles();


  
  const submitHandler = (e, w) => {
    e.preventDefault();
    
    if (updateId) {
      PutRefrenceDataList(formState,setFormState,setSuccessMessage,setErrorMessage,setLoader,
  setGetData,
  handleClose,
        
        );

    } else {

      AddRefrenceDataList(
        formState,
        setFormState,
        setLoader,
        setSuccessMessage,
        setErrorMessage,
  setGetData,

      handleClose

      );
      // getRefrenceDataList("InvoiceType",setGetData,()=>{},()=>{},()=>{},()=>{},()=>{},()=>{});
    }
  };
 
useEffect(() => {

  
}, [loader]);
  
  const enableDisable = () => {
    PutRefrenceDataList(
      formState,
      setFormState,
      setSuccessMessage,
      setErrorMessage,
      setLoader,
  setGetData,

      handleClose


    );

    
  };
  const Delete = () => {
    deleteItem(
      formState,
      setFormState,
      deleteId,
      setLoader,
      setSuccessMessage,
      setErrorMessage,
  setGetData,

    handleClose

    );
  };

  
  const clearState = (setFormState,setUpdateId,setDeleteID, settogglebutton,setGetDataFromID) => {
    setFormState((formState) => ({
      ...formState,
      referenceId: 0,
      referenceKey: refKey,
      referenceCode: "",
      referenceText: "",
      referenceProp1: "",
      referenceProp2: "",
      referenceProp3: "",
      referenceProp4: "",
      isActive: true,
    }));

    setUpdateId("");
    setDeleteID("");
    settogglebutton("")
    setGetDataFromID("")
    setChecked("")
  };
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
    
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenModel(false);
   
    clearState(setFormState,setUpdateId,setDeleteID, settogglebutton,setGetDataFromID);

    // setErrAlertMessage("")
  };



// useEffect(()=>{
//   if(formState?.referenceProp3){
//     setFormState((formState)=>({
//       ...formState,
//       referenceProp3:"true"
//     }));

//   }else{
//     setFormState((formState)=>({
//       ...formState,
//       referenceProp3:""
//     }));
//   }
// },[formState?.referenceProp3])

const [enable, setEnable] = useState(false)
  useEffect(() => {
    handleClickOpen();
  
   
    if (updateId || deleteId) {
      if (getdataFromID) {
        const update = getdata.filter(
          (value) => getdataFromID === value.referenceId
        );
        

        setFormState((formState) => ({
          ...formState,
          referenceId: update[0]?.referenceId,
          referenceKey: update[0]?.referenceKey,
          referenceCode: update[0]?.referenceCode,
          referenceText: update[0]?.referenceText,
          referenceProp1: update[0]?.referenceProp1,
          referenceProp2: update[0]?.referenceProp2,
          referenceProp3: update[0]?.referenceProp3,
          referenceProp4: update[0]?.referenceProp4 || "",
          isActive: update[0]?.isActive ? true : false,
        }));
    } 
  }else if (togglebutton) {
        
        const toggle = getdata.filter(
          (value) => togglebutton === value.referenceId
        );
        

        setFormState((formState) => ({
          ...formState,
          referenceId: toggle[0]?.referenceId,
          referenceKey: toggle[0]?.referenceKey,
          referenceCode: toggle[0]?.referenceCode||"",
          referenceText: toggle[0]?.referenceText||"",
          referenceProp1: toggle[0]?.referenceProp1||"",
          referenceProp2: toggle[0]?.referenceProp2||"",
          referenceProp3: toggle[0]?.referenceProp3 ||"",
          referenceProp4: toggle[0]?.referenceProp4 || "",
          isActive: toggle[0]?.isActive ? false : true,
        }));
        setEnable(toggle[0]?.isActive )
    }
    // get_Location();
  }, [updateId,deleteId,togglebutton]);

  
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        // sx={{ width: "60%" }}
        fullWidth={true}
      >
        {deleteId ? (
          <>
            <DialogContent>
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={loader}
              >
                <CircularProgress color="inherit" />
              </Backdrop>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <HelpOutline color="secondary" fontSize="large" mt={2} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                p={2}
                mt={1}
              >
                <Typography variant="h4" style={{ width: "80%" }}>
                  Are you sure you want to Delete a User?
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                }}
                m={1}
              >
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                >
                  NO
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ marginLeft: "20px" }}
                  onClick={Delete}
                >
                  Yes
                </Button>
              </Box>
            </DialogContent>
          </>
        ) : (
          <>
            {togglebutton ? (
              <>
                <DialogContent>
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={loader}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <HelpOutline color="secondary" fontSize="large" mt={2} />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    p={2}
                    mt={1}
                  >
                    <Typography variant="h4" style={{ width: "80%" }}>
                    {enable ?"Are you sure you want to Disable this Item?" : "Are you sure you want to Enable this Item?" }
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    m={1}
                  >
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleClose}
                    >
                      NO
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      style={{ marginLeft: "20px" }}
                      onClick={enableDisable}
                    >
                      Yes
                    </Button>
                  </Box>
                </DialogContent>
              </>
            ) : (
              <>
                <form onSubmit={(e) => submitHandler(e)}>
                  <DialogTitle
                    sx={{
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                  >
                    {refKey === "PaymentMethod" ? "PaymentMethod" : refKey==="SGLInd" ? "SGLInd": refKey==="TType" ? "TType" : "PostingKey"}
                  </DialogTitle>
                  <Divider />
                  <DialogContent>
                    <Backdrop
                      sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                      }}
                      open={loader}
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>
                    <Grid container spacing={2} pb={3}>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          id="outlined-basic"
                          label="Code"
                          name="referenceCode"
                          variant="outlined"
                          value={formState.referenceCode}
                          onChange={changeHandler}
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <TextField
                          size="small"
                          fullWidth
                          id="outlined-basic"
                          label="Description"
                          name="referenceText"
                          variant="outlined"
                          value={formState.referenceText}
                          onChange={changeHandler}
                          required
                        />
                      </Grid>
                      {refKey==="PaymentTerm" &&(
                       <Grid item xs={12} sm={12} md={6} lg={6}>
                       <TextField
                         size="small"
                         fullWidth
                         id="outlined-basic"
                         label="No of days"
                         name="referenceProp1"
                         variant="outlined"
                         type="number"
                         value={formState.referenceProp1}
                         onChange={changeHandler}
                         required
                       />
                     </Grid>
                    )}
                        {refKey==="SupervisorLevel" &&(
                          <>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                       <TextField
                         size="small"
                         fullWidth
                         id="outlined-basic"
                         label="Limit from (in million)"
                         name="referenceProp1"
                         variant="outlined"
                         type="number"
                         value={formState.referenceProp1}
                         onChange={changeHandler}
                         required
                       />
                     </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        id="outlined-basic"
                        label="Limit to (in million)"

                        name="referenceProp2"
                        variant="outlined"
                        type="number"
                        value={formState.referenceProp2}
                        onChange={changeHandler}
                        required
                      />
                    </Grid>
                          </>
                     
                    )}
                     {refKey==="PostingKey" &&(
                          <>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                       <TextField
                         size="small"
                         fullWidth
                         id="outlined-basic"
                         label="Type"
                         name="referenceProp1"
                         variant="outlined"
                         type="text"
                         value={formState.referenceProp1}
                         onChange={changeHandler}
                         required
                       />
                     </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        id="outlined-basic"
                        label="Debit/Credit"

                        name="referenceProp2"
                        variant="outlined"
                        type="text"
                        value={formState.referenceProp2}
                        onChange={changeHandler}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        size="small"
                        fullWidth
                        id="Input"
                        label="Input"

                        name="referenceProp4"
                        variant="outlined"
                        type="text"
                        value={formState.referenceProp4}
                        onChange={changeHandler}
                        required
                      />
                    </Grid>
                          </>
                     
                    )}
                    
                      
                    </Grid>
                  
                  </DialogContent>
                  <Divider />

                  <DialogActions>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                    {updateId ? (
                      <Button
                        color="success"
                        variant="contained"
                         type="submit"
                          // onClick={()=>}
                      >
                        Updated
                      </Button>
                    ) : (
                      <Button
                        color="success"
                        variant="contained"
                        type="submit"
                        //   onClick={add_role_data}
                      >
                        Save
                      </Button>
                    )}
                  </DialogActions>
                </form>
              </>
            )}
          </>
        )}
      </Dialog>
    </>
  );
}
